<template>
  <table class="items-center w-full bg-transparent border-collapse">
    <TableHead :headers="['ID', 'Name']" />
    <tbody>
      <CategoryInstanceTableRow
        v-for="(value, index) in filteredCategoryInfo.slice(from, to)"
        :key="index"
        :data="value"
        :exsitCategoryName="exsitCategoryName"
        :handleEdit="handleEdit"
        :handleCreate="handleCreate"
      />
    </tbody>
  </table>
  <TableNavigation
    class="mr-4 rounded-b-md"
    :from="from + 1"
    :to="to"
    :total="filteredCategoryInfo.length"
    :navigate="navigate"
    :itemPerPage="itemPerPage"
    @update:itemPerPage="handleChangeItemNumber"
  />
</template>

<script>
import { mapGetters } from "vuex";
import * as Actions from "@/store/actions.type";
import TableHead from "@/components/Shared/Table/TableHead";
import TableNavigation from "@/components/Shared/Table/TableNavigation";
import CategoryInstanceTableRow from "@/components/ComponentModule/InstanceTable/CategoryInstanceTableRow";

export default {
  name: "CategoryInstanceTable",
  components: {
    TableHead,
    CategoryInstanceTableRow,
    TableNavigation
  },
  data() {
    return {
      itemPerPage: 10
    };
  },
  watch: {
    itemPerPage() {
      this.$store.dispatch(Actions.SET_CATEGORY_PAGE, 0);
    }
  },
  computed: {
    from() {
      const itemPerPage = this.itemPerPage || 10;
      return this.categoryPageNum * itemPerPage;
    },
    to() {
      const itemPerPage = this.itemPerPage || 10;
      if (
        (this.categoryPageNum + 1) * itemPerPage <
        this.filteredCategoryInfo.length
      ) {
        return this.from + itemPerPage;
      } else {
        return this.filteredCategoryInfo.length;
      }
    },
    ...mapGetters([
      "filteredCategoryInfo",
      "categoryPageNum",
      "exsitCategoryName",
      "operationMode"
    ])
  },
  methods: {
    navigate(step) {
      if (step === "prev" && this.categoryPageNum !== 0) {
        this.$store.dispatch(
          Actions.SET_CATEGORY_PAGE,
          this.categoryPageNum - 1
        );
      }
      if (
        step === "next" &&
        (this.categoryPageNum + 1) * this.itemPerPage <
          this.filteredCategoryInfo.length
      ) {
        this.$store.dispatch(
          Actions.SET_CATEGORY_PAGE,
          this.categoryPageNum + 1
        );
      }
    },
    handleChangeItemNumber(val) {
      this.itemPerPage = val;
    },
    handleEdit(categoryName) {
      this.$store.dispatch(Actions.CHANGE_CATEGORY_OPERATION, "edit");
      this.$router.push(`/component/category-page/edit/${categoryName}`);
    },
    handleCreate(categoryName) {
      this.$store.dispatch(Actions.CHANGE_CATEGORY_OPERATION, "create");
      this.$router.push(`/component/category-page/create/${categoryName}`);
    }
  }
};
</script>
